import React, { useContext, useEffect } from "react"

// Components
import ParticipantSidebar from "../../components/sidebars/ParticipantSidebar"
import AdvancedSearch from "./components/AdvancedSearch"
import PageSidebarContent from "../../components/sidebars/PageSidebarContent"

import { UserContext } from "../../context/userContext"

export default function MyParticipants() {
  const userCtx = useContext(UserContext)

  useEffect(() => {
    userCtx.clearParticipant()
  }, [])

  return (
    <>
      <PageSidebarContent>
        <ParticipantSidebar searchType="my_participants" />
      </PageSidebarContent>
      <div className="main-content">
        <h1>My Participants</h1>
        <AdvancedSearch searchType="my_participants" />
      </div>
    </>
  )
}
